import { TextContent } from '../text-content';
import { UserGroup } from '../user-group.model';
import { User } from '../user.model';
import { CRMStatus } from './CRMStatus';
import { CRMCompanyStorm } from './CRMCompanyStorm';
import { CompanyBasic } from '..';
import { CourtshipTypeEnum } from '../../enums/courtship-type.enum';
import { CRMAlarm } from './CRMAlarm.model';
import { Domain } from '../domain.model';
import { RecentNoteData } from './RecentNoteData.model';
import { CrmItemType } from '../../enums/crm-item-type.enum';

export type CrmCompany = {
    updated: Date;
    created: Date;
    updatedBy: User;
    createdBy: User;
} & CompanyBasic;

export interface CrmItemSnapshot {
  id: number;
  created: Date;
  status: string;
  storm: string;
  courtship: string;
  etaki: string;
  silencedUntil: string;
}

export class BaseCRMItem {
  id: number;
  name: string;
  created: Date;
  updated: Date;
  createdBy: User;
  updatedBy: User;
  lastStatusTimestamp: Date;
  archived: boolean;
  description: string;
  lastActivity: Date;
  silenceUntil?: Date;
  indicated?: number;
  received?: number;
  externalIds?: Array<{externalId: string, idType: string}>;
  groups: Array<UserGroup & {
    updated?: Date;
    created?: Date;
  }>;
  domains: Array<Domain>;
  notes: Array<{
    id: number,
    textContent: TextContent,
    itemSnapshot: CrmItemSnapshot
  }>;
  recentNotes?: RecentNoteData;
  leader: {
    id?: number;
    updated: Date;
    created: Date;
    user: User;
    confirmed: boolean;
    emailAddress?: string;
  };
  triageOwner: {
    id?: number;
    updated: Date;
    created: Date;
    user: User;
    confirmed: boolean;
    emailAddress?: string;
  };
  participants: Array<{
    updated: Date;
    created: Date;
    user: User;
    confirmed: boolean;
    emailAddress?: string;
  }>;
  companies: Array<{
    companyId?: number,
    storm: CRMCompanyStorm,
    etaki: string,
    courtshipType?: CourtshipTypeEnum,
    company: CrmCompany,
    updated?: Date;
    created?: Date;
  }>;
  alarms: Array<CRMAlarm & {
    updated?: Date;
    created?: Date;
  }>;
  status: any;
  itemType?: CrmItemType;
}

export class CRMItem extends BaseCRMItem {
  status: CRMStatus;
}

export class WatchedItem {
  company: CompanyBasic;
  positionType?: string;
  intradaySummary?: any;
  percentChange?: number;
  updated: string;
  notes?: Array<TextContent>;
}
